export const SystemLogsPage = () => {
    return <></>
}